
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { BrandModel } from './Entities.GormCrm.Brand';
import { CompanyModel } from './Entities.GormCrm.Company';
import { OrderProductPlanDiscontinuationModel } from './Entities.GormCrm.OrderProductPlanDiscontinuation';
import { PlanReplacementNewPlanModel } from './Entities.GormCrm.PlanReplacementNewPlan';
import { PlanReplacementOldPlanModel } from './Entities.GormCrm.PlanReplacementOldPlan';
import { ProductPlanTagModel } from './Entities.GormCrm.ProductPlanTag';
import { SettlementProductPlanModel } from './Entities.GormCrm.SettlementProductPlan';
import { ReasonModel } from './Entities.GormCrm.Reason';
import { TransferPlanModel } from './Entities.GormCrm.TransferPlan';
import { OrderLineModel } from './Entities.GormCrm.OrderLine';
import { TaskflowModel } from './Entities.GormCrm.Taskflow';
import { Model, ModelProperty } from 'models/Model';


export class ProductPlanModel extends Model<ProductPlanModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'productPlan.property.id', isHidden: true },
		{ name: 'parentId', type: 'guid', languageString: 'productPlan.property.parentId' },
		{ name: 'companyId', type: 'guid', languageString: 'productPlan.property.companyId' },
		{ name: 'productName', type: 'string', languageString: 'productPlan.property.productName' },
		{ name: 'productIdentification', type: 'string', languageString: 'productPlan.property.productIdentification' },
		{ name: 'terminationDate', type: 'Date', languageString: 'productPlan.property.terminationDate' },
		{ name: 'terminationReasonId', type: 'guid', languageString: 'productPlan.property.terminationReasonId' },
		{ name: 'autoRenewalDate', type: 'Date', languageString: 'productPlan.property.autoRenewalDate' },
		{ name: 'nextPeriod', type: 'number', languageString: 'productPlan.property.nextPeriod' },
		{ name: 'annualValueForRenewal', type: 'number', languageString: 'productPlan.property.annualValueForRenewal' },
		{ name: 'unitPrice', type: 'number', languageString: 'productPlan.property.unitPrice' },
		{ name: 'units', type: 'number', languageString: 'productPlan.property.units' },
		{ name: 'paymentScheme', type: 'number', languageString: 'productPlan.property.paymentScheme' },
		{ name: 'autoRenewable', type: 'boolean', languageString: 'productPlan.property.autoRenewable' },
		{ name: 'deliveryDate', type: 'Date', languageString: 'productPlan.property.deliveryDate' },
		{ name: 'terminationNoticePeriod', type: 'number', languageString: 'productPlan.property.terminationNoticePeriod' },
		{ name: 'restrictEndDate', type: 'Date', languageString: 'productPlan.property.restrictEndDate' },
		{ name: 'brandId', type: 'guid', languageString: 'productPlan.property.brandId' },
		{ name: 'brand', type: 'BrandModel', languageString: 'productPlan.property.brand', isHidden: true, isObject: true, new: () => { return new BrandModel }, properties: () => { return BrandModel.classProperties } },
		{ name: 'company', type: 'CompanyModel', languageString: 'productPlan.property.company', isHidden: true, isObject: true, new: () => { return new CompanyModel }, properties: () => { return CompanyModel.classProperties } },
		{ name: 'inverseParent', type: 'ProductPlanModel[]', languageString: 'productPlan.property.inverseParent', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductPlanModel }, properties: () => { return ProductPlanModel.classProperties } },
		{ name: 'orderProductPlanDiscontinuations', type: 'OrderProductPlanDiscontinuationModel[]', languageString: 'productPlan.property.orderProductPlanDiscontinuations', isHidden: true, isArray: true, isObject: true, new: () => { return new OrderProductPlanDiscontinuationModel }, properties: () => { return OrderProductPlanDiscontinuationModel.classProperties } },
		{ name: 'parent', type: 'ProductPlanModel', languageString: 'productPlan.property.parent', isHidden: true, isObject: true, new: () => { return new ProductPlanModel }, properties: () => { return ProductPlanModel.classProperties } },
		{ name: 'planReplacementNewPlans', type: 'PlanReplacementNewPlanModel[]', languageString: 'productPlan.property.planReplacementNewPlans', isHidden: true, isArray: true, isObject: true, new: () => { return new PlanReplacementNewPlanModel }, properties: () => { return PlanReplacementNewPlanModel.classProperties } },
		{ name: 'planReplacementOldPlans', type: 'PlanReplacementOldPlanModel[]', languageString: 'productPlan.property.planReplacementOldPlans', isHidden: true, isArray: true, isObject: true, new: () => { return new PlanReplacementOldPlanModel }, properties: () => { return PlanReplacementOldPlanModel.classProperties } },
		{ name: 'productPlanTags', type: 'ProductPlanTagModel[]', languageString: 'productPlan.property.productPlanTags', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductPlanTagModel }, properties: () => { return ProductPlanTagModel.classProperties } },
		{ name: 'settlementProductPlans', type: 'SettlementProductPlanModel[]', languageString: 'productPlan.property.settlementProductPlans', isHidden: true, isArray: true, isObject: true, new: () => { return new SettlementProductPlanModel }, properties: () => { return SettlementProductPlanModel.classProperties } },
		{ name: 'terminationReason', type: 'ReasonModel', languageString: 'productPlan.property.terminationReason', isHidden: true, isObject: true, new: () => { return new ReasonModel }, properties: () => { return ReasonModel.classProperties } },
		{ name: 'transferPlans', type: 'TransferPlanModel[]', languageString: 'productPlan.property.transferPlans', isHidden: true, isArray: true, isObject: true, new: () => { return new TransferPlanModel }, properties: () => { return TransferPlanModel.classProperties } },
		{ name: 'orderLines', type: 'OrderLineModel[]', languageString: 'productPlan.property.orderLines', isHidden: true, isArray: true, isObject: true, new: () => { return new OrderLineModel }, properties: () => { return OrderLineModel.classProperties } },
		{ name: 'taskflows', type: 'TaskflowModel[]', languageString: 'productPlan.property.taskflows', isHidden: true, isArray: true, isObject: true, new: () => { return new TaskflowModel }, properties: () => { return TaskflowModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public parentId?: string;
	public companyId?: string;
	public productName: string;
	public productIdentification: string;
	public terminationDate?: Date;
	public terminationReasonId?: string;
	public autoRenewalDate?: Date;
	public nextPeriod?: number;
	public annualValueForRenewal: number;
	public unitPrice?: number;
	public units?: number;
	public paymentScheme?: number;
	public autoRenewable: boolean;
	public deliveryDate?: Date;
	public terminationNoticePeriod: number;
	public restrictEndDate?: Date;
	public brandId?: string;
	public brand?: BrandModel;
	public company?: CompanyModel;
	public inverseParent: ProductPlanModel[];
	public orderProductPlanDiscontinuations: OrderProductPlanDiscontinuationModel[];
	public parent?: ProductPlanModel;
	public planReplacementNewPlans: PlanReplacementNewPlanModel[];
	public planReplacementOldPlans: PlanReplacementOldPlanModel[];
	public productPlanTags: ProductPlanTagModel[];
	public settlementProductPlans: SettlementProductPlanModel[];
	public terminationReason?: ReasonModel;
	public transferPlans: TransferPlanModel[];
	public orderLines: OrderLineModel[];
	public taskflows: TaskflowModel[];
    
	constructor(){
		super();
		this.id = undefined;
		this.parentId = undefined;
		this.companyId = undefined;
		this.productName = '';
		this.productIdentification = '';
		this.terminationDate = undefined;
		this.terminationReasonId = undefined;
		this.autoRenewalDate = undefined;
		this.nextPeriod = undefined;
		this.annualValueForRenewal = 0;
		this.unitPrice = undefined;
		this.units = undefined;
		this.paymentScheme = undefined;
		this.autoRenewable = false;
		this.deliveryDate = undefined;
		this.terminationNoticePeriod = 0;
		this.restrictEndDate = undefined;
		this.brandId = undefined;
		this.brand = undefined;
		this.company = undefined;
		this.inverseParent = [];
		this.orderProductPlanDiscontinuations = [];
		this.parent = undefined;
		this.planReplacementNewPlans = [];
		this.planReplacementOldPlans = [];
		this.productPlanTags = [];
		this.settlementProductPlans = [];
		this.terminationReason = undefined;
		this.transferPlans = [];
		this.orderLines = [];
		this.taskflows = [];
		
	}
	getProperties(){
		return ProductPlanModel.classProperties;
	}
}

